import { render, staticRenderFns } from "./propertyFeeReport.vue?vue&type=template&id=4283f518&"
import script from "./propertyFeeReport.vue?vue&type=script&lang=js&"
export * from "./propertyFeeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports